const lngs = {
    en: {NativeName: 'EN'},   
    spa: {NativeName: 'SPA'}
  }

  export default lngs;